import { useQuery } from '@apollo/client';
import { getSubAccountName } from '@interfaces/subAccount';
import type { SubAccountBilling } from '@interfaces/subAccountBilling';
import { useParams } from 'react-router';
import { useLocalization } from '../../hooks/useLocalization';

import { FETCH_SUB_ACCOUNT_BILLING_BREADCRUMB } from './dailyFeeDetailsBreadcrumb.query';

export const DailyFeeDetailsBreadcrumb = () => {
  const { translateBackendString } = useLocalization();
  const { data } = useQuery(FETCH_SUB_ACCOUNT_BILLING_BREADCRUMB, {
    variables: {
      input: {
        filter: {
          subAccountIds: useParams().subAccountId,
          billingCycleIds: useParams().billingCycleId,
        },
      },
    },
  });
  const subAccountBilling: SubAccountBilling =
    data?.fetchSubAccountBillings?.subAccountBillings?.[0];
  if (!subAccountBilling?.subAccount) return '';

  return `${getSubAccountName(translateBackendString, subAccountBilling?.subAccount, true)}`;
};
